import React from "react";
import DataTable from "react-data-table-component";
import { Toaster, toast } from "react-hot-toast";
import Sidebar from "../Components/Sidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import CreateApiChannelModal from "../Components/CreateApiChannelModal";
import EditApiChannelModal from "../Components/EditApiChannelModal";
import { useApiChannelTable } from "../hooks/useApiChannelTable";
import { getApiChannelTableColumns } from "../Components/ApiChannelTableColumns";
import { ApiChannelFormData } from "../types/apiChannel.types";
import OverlayLoader from "../Components/OverlayLoader";

const ApiChannelTable: React.FC = () => {
  const {
    isSidebarCollapsed,
    toggleSidebar,
    isLoading,
    loading,
    error,
    searchText,
    setSearchText,
    filteredApiChannels,
    fetchApiChannelData,
    isModalOpen,
    setIsModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    editApiChannelData,
    setEditApiChannelData,
    selectedRows,
    toggleCleared,
    handleRowSelected,
    handleEdit,
  } = useApiChannelTable();

  const handleCreateApiChannel = (data: ApiChannelFormData) => {
    toast.success(`API channel created successfully`);
    fetchApiChannelData();
  };

  const handleEditSubmit = (updatedData: ApiChannelFormData) => {
    setIsEditModalOpen(false);
    setEditApiChannelData(null);
    fetchApiChannelData();
    toast.success("API channel updated successfully");
  };

  const columns = getApiChannelTableColumns(handleEdit);

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="wrapper">
      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={{
          zIndex: 10000,
        }}
      />
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-header carHeaderWithBtn">
                      <div className="card-title mb-0">API Channels List</div>
                      <div>
                        <input
                          type="text"
                          placeholder="Search by Channel Name or API Type"
                          className="p-2 w-full datatableSearchInput"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button
                          className="demo-btn btn btn-outline-primary btn-sm"
                          onClick={() => setIsModalOpen(true)}
                        >
                          +Add API Channel
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <DataTable
                        columns={columns}
                        data={filteredApiChannels}
                        pagination
                        paginationPerPage={10}
                        highlightOnHover
                        striped
                        responsive
                        noDataComponent="No API channels found"
                        selectableRows
                        selectableRowsComponentProps={{
                          className: "custom-checkbox",
                        }}
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleCleared}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CreateApiChannelModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onSubmit={handleCreateApiChannel}
            />
            <EditApiChannelModal
              isOpen={isEditModalOpen}
              onClose={() => {
                setIsEditModalOpen(false);
                setEditApiChannelData(null);
              }}
              onSubmit={handleEditSubmit}
              editApiChannelData={editApiChannelData}
            />
          </main>
        </div>
        <Footer />
      </div>
      <OverlayLoader
        loading={loading}
        message="Loading API Channel Data"
        submessage="This might take a moment..."
      />
    </div>
  );
};

export default ApiChannelTable;
